<template>
  <div class="vis-wizard-view">
    <vis-product-request-container
      class="vis-wizard-view__container"
      :serviceId="serviceId"
      :productId="productId"
      :subjectId="subjectId"
      :departmentId="departmentId"
      @hide="onItemHide"
    />
  </div>
</template>

<script>
import RemoteCrudService from "@/shared/services/remote-crud-service";
import VisProductRequestContainer from "@/views/base/common/vis-product-request-container"
import Vue from "vue";

import globalState from "@/shared/global-state";
import { administratorEip } from '@/shared/enum/user-catigories';

const LIST_VIEW_ROUTE_NAME = 'List View'
const PRODUCT_REQUEST_ENTITY_NAME = 'ProductRequest'

export default {
  name: "vis-wizard-view",
  props: {
    mnemonic: { type: String, required: true },
    serviceId: { type: String, required: false },
    productId: { type: String, required: false },
    subjectId: { type: String, required: false },
    departmentId: { type: String, required: false },
  },
  components: {
    VisProductRequestContainer,
  },
  data() {
    return {
      detailView: { readonly: false, context: {} },
      crudService: null,
      eventBus: new Vue()
    }
  },
  methods: {
    onItemHide(event = {}) {
      if (
        this.$route.name === 'Wizard' || (
          event.isSuccessful && !(
            this.$route.name === LIST_VIEW_ROUTE_NAME && (
              this.$route.params.mnemonic === this.mnemonic || (
                this.$parent.config?.EntityName === PRODUCT_REQUEST_ENTITY_NAME && this.mnemonic === PRODUCT_REQUEST_ENTITY_NAME.toLowerCase()
              )
            )
          )
        )
      ) {
        this.$router.replace({
          name: LIST_VIEW_ROUTE_NAME,
          params: { mnemonic: this.mnemonic },
        })
      } else {
        this.$emit('hide')
      }
    },
  },
  created() {
    const isAdminEIP = globalState?.currentUser?.Categories && globalState.currentUser.Categories.includes(administratorEip);

    if (isAdminEIP) {
      this.$router.replace('/home');
      return;
    }

    this.eventBus = new Vue();
    this.crudService = new RemoteCrudService(this.mnemonic);
  },
  destroyed() {
    if(this.eventBus)
      this.eventBus.$destroy();
  }
};
</script>
